import Swiper from 'swiper';
import 'swiper/css';

document.addEventListener('DOMContentLoaded', function() {

    // Detect today's index from DOM
    const todaySlide = document.querySelector('.swiper-slide.is-today');
    const todayIndex = [...document.querySelectorAll('.swiper-slide')].indexOf(todaySlide);

    // Init Swiper
   window.swiperTimetable = new Swiper('.class-timetable-swiper.swiper', {
        slidesPerView: 2.3,
        centeredSlides: true,
        spaceBetween: 15,
        initialSlide: todayIndex !== -1 ? todayIndex : 0,
        autoHeight: false,

        breakpoints: {
            600: {
                slidesPerView: 3.5,
            },
            768: {
                slidesPerView: 4.2,
            },
            1024: {
                slidesPerView: 7,
                centeredSlides: false,
            },
        },
    });

    window.swiperTimetable.slideTo(normalizeWeekdayIndex(), 0);
});

function normalizeWeekdayIndex(date = new Date()) {
  return (date.getDay() + 6) % 7;
}


function updateDayLabels() {
  const offsetTop = 90;
  const swiper = document.querySelector('.class-timetable-swiper');
  const columns = document.querySelectorAll('.swiper-slide');

  if (!swiper) return;

  const swiperRect = swiper.getBoundingClientRect();
  const swiperTop = swiperRect.top;
  const swiperBottom = swiperRect.bottom;
  const windowHeight = window.innerHeight;

  const swiperVisible = swiperBottom > 0 && swiperTop < windowHeight;
  if (!swiperVisible) {
    columns.forEach(column => {
      const label = column.querySelector('.day-label');
      if (!label) return;

      label.style.transform = `translateY(-200%)`;
      label.style.opacity = '0';
    });
    return;
  }

  const swiperHeight = swiper.offsetHeight;

  columns.forEach(column => {
    const label = column.querySelector('.day-label');
    if (!label) return;

    const columnRect = column.getBoundingClientRect();
    const labelHeight = label.offsetHeight;
    const colTop = columnRect.top;

    let translateY = 0;

    if (colTop < offsetTop) {
      const desired = offsetTop - colTop;

      // Stop scrolling label before it would overflow swiper bottom
      const maxTranslate = swiperHeight - labelHeight;
      translateY = Math.min(desired, maxTranslate);
    }

    label.style.transform = `translateY(${translateY}px)`;
    label.style.opacity = '1';
  });

  window.swiperTimetable.update();
}

function equalizeCardHeights(container = 'section.class-timetable') {
  if (container instanceof Event) container = 'section.class-timetable';
  const slides = document.querySelectorAll(`${container} .swiper-slide`);

  const rows = [];

  slides.forEach(slide => {
    const cards = slide.querySelectorAll('.class-card');

    cards.forEach((card, rowIndex) => {
      if (!rows[rowIndex]) rows[rowIndex] = [];
      rows[rowIndex].push(card);
    });
  });

  // Reset heights
  rows.flat().forEach(card => {
    card.style.height = 'auto';
  });

  // Same height row
  rows.forEach(cardsInRow => {
    const maxHeight = Math.max(...cardsInRow.map(c => c.offsetHeight));
    cardsInRow.forEach(c => {
      c.style.height = `${maxHeight}px`;
    });
  });

  window.swiperTimetable.update();
}

function fixSwiperHeight(container = 'section.class-timetable') {
  if (container instanceof Event) container = 'section.class-timetable';

  const slides = document.querySelectorAll(`${container} .swiper-slide`);
  if (slides.length === 0) return;

  let tallest = 0;

  slides.forEach(slide => {
    // Reset inline height first
    slide.style.setProperty('height', 'auto', 'important');

    // Use inner content height if needed
    const content = slide.querySelector('.day-column-wrapper') || slide;
    const contentHeight = content.scrollHeight;

    tallest = Math.max(tallest, contentHeight);
  });

  slides.forEach(slide => {
    slide.style.setProperty('height', `${tallest}px`, 'important');
  });

  // Update Swiper AFTER setting heights
  if (window.swiperTimetable?.update) {
    window.swiperTimetable.update();
  }
}

// Run after DOM is ready

document.addEventListener('DOMContentLoaded', () => {
  equalizeCardHeights();
  // fixSwiperHeight();
  updateDayLabels();
});

window.addEventListener('resize', () => {
  equalizeCardHeights();
  // fixSwiperHeight();
  updateDayLabels();
});

window.addEventListener('scroll', updateDayLabels, { passive: true });

